Object.defineProperty(exports, "__esModule", { value: true });
var Azure;
(function (Azure) {
    Azure[Azure["#3A79DE"] = 100] = "#3A79DE";
    Azure[Azure["#3771D0"] = 200] = "#3771D0";
    Azure[Azure["#3064B8"] = 300] = "#3064B8";
    Azure[Azure["#264F91"] = 400] = "#264F91";
    Azure[Azure["#152C52"] = 500] = "#152C52";
})(Azure = exports.Azure || (exports.Azure = {}));
var Crimson;
(function (Crimson) {
    Crimson[Crimson["#C90036"] = 100] = "#C90036";
    Crimson[Crimson["#BC0031"] = 200] = "#BC0031";
    Crimson[Crimson["#A3002C"] = 300] = "#A3002C";
    Crimson[Crimson["#7D0021"] = 400] = "#7D0021";
    Crimson[Crimson["#3D0010"] = 500] = "#3D0010";
})(Crimson = exports.Crimson || (exports.Crimson = {}));
var Emerald;
(function (Emerald) {
    Emerald[Emerald["#27CC74"] = 100] = "#27CC74";
    Emerald[Emerald["#1B8C50"] = 200] = "#1B8C50";
    Emerald[Emerald["#188049"] = 300] = "#188049";
    Emerald[Emerald["#13663A"] = 400] = "#13663A";
    Emerald[Emerald["#0C4024"] = 500] = "#0C4024";
})(Emerald = exports.Emerald || (exports.Emerald = {}));
var Slate;
(function (Slate) {
    Slate[Slate["#A5AFC4"] = 100] = "#A5AFC4";
    Slate[Slate["#6F7685"] = 200] = "#6F7685";
    Slate[Slate["#3A3E45"] = 300] = "#3A3E45";
    Slate[Slate["#2E3137"] = 400] = "#2E3137";
    Slate[Slate["#2B2E33"] = 500] = "#2B2E33";
})(Slate = exports.Slate || (exports.Slate = {}));
var Grey;
(function (Grey) {
    Grey[Grey["#F5F5F5"] = 100] = "#F5F5F5";
    Grey[Grey["#DBDBDB"] = 200] = "#DBDBDB";
    Grey[Grey["#B5B5B5"] = 300] = "#B5B5B5";
    Grey[Grey["#757575"] = 400] = "#757575";
    Grey[Grey["#363636"] = 500] = "#363636";
})(Grey = exports.Grey || (exports.Grey = {}));
//# sourceMappingURL=colors.js.map